import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorBase } from '@fi-shared/control-value-accessor-validator-base';
import { FiCommentSettingType, FiCommentSettingTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-comments-settings',
    templateUrl: './fi-comments-settings.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./fi-comments-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiCommentsSettingsComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiCommentsSettingsComponent extends ControlValueAccessorBase<FiCommentSettingType> {
    CommentSettingTypes = FiCommentSettingTypes;

    onCommentTypeChange() {
        this.doPropagateChanges();
    }
}
